import './SectionHeader.css';

function SectionHeader(props) {
  return (
    <>
    <div className='section-header'>
      <div>
        <h3>{props.title}</h3>
        <p>{props.disc}</p>
      </div>
    </div>
    </>
    )
}

export default SectionHeader